/* Spardosen-Konfigurator
 * Illustration (Kacheln) und Name (Pflicht) live auf der Spardose.
 * Vorschaubild: Datei spardose-mockup.jpg, Overlay-Positionen in
 * snippets/spardose-vorschau-stage.liquid. Aufbau wie taufkerze-vorschau.js.
 */
(function () {
  'use strict';

  var GHOST_NAME = 'Milla';
  var FIG_SCALE = { baby: 0.88, junge: 1, maedchen: 1 }; /* wie SCALE im spardose_generator */
  var FIG_H = 0.284; /* 44 mm Figurhöhe als Anteil der Bildhöhe */

  function boot() {
    var fields = document.querySelector('[data-spardose-vorschau]');
    var wrap = document.querySelector('[data-spardose-stage-wrap]');
    if (!fields || !wrap || wrap.dataset.spardoseInit) return;
    wrap.dataset.spardoseInit = '1';

    var stage = wrap.querySelector('[data-spardose-stage]');
    var img = wrap.querySelector('[data-spardose-img]');
    var figur = wrap.querySelector('[data-spardose-figur]');
    var nameEl = wrap.querySelector('[data-spardose-text-name]');

    var nameInput = fields.querySelector('[data-spardose-name]');
    var errorEl = fields.querySelector('[data-spardose-error]');
    var motivRadios = Array.prototype.slice.call(fields.querySelectorAll('[data-spardose-motiv]'));
    var motivLabel = fields.querySelector('[data-spardose-motiv-label]');
    var tabs = Array.prototype.slice.call(fields.querySelectorAll('[data-spardose-tab]'));
    var panels = Array.prototype.slice.call(fields.querySelectorAll('[data-spardose-panel]'));
    var showLink = fields.querySelector('[data-spardose-show]');

    function checkedMotiv() {
      for (var i = 0; i < motivRadios.length; i++) {
        if (motivRadios[i].checked) return motivRadios[i];
      }
      return motivRadios[0];
    }

    function layoutStage() {
      var w = stage.clientWidth;
      var h = stage.clientHeight;
      if (!w || !h) return 0;
      /* Bild ist object-fit: contain, oben zentriert. Die Anker beziehen sich auf die
         tatsaechlich gezeichnete Bildbreite, gemessen an der Box des <img> selbst. */
      var ratio = (img.naturalWidth && img.naturalHeight) ? img.naturalHeight / img.naturalWidth : 1;
      var sb = stage.getBoundingClientRect();
      var ib = img.getBoundingClientRect();
      var bw = ib.width || w;
      var bh = ib.height || h;
      var s = Math.min(bw, bh / ratio);
      wrap.style.setProperty('--is', s + 'px');
      wrap.style.setProperty('--ix', ((bw - s) / 2 + (ib.left - sb.left)) + 'px');
      wrap.style.setProperty('--iy', (ib.top - sb.top) + 'px');
      return s;
    }

    function fit(el, size, maxW, min) {
      /* proportional statt in 1-px-Schritten: lange Namen liefen sonst nach 40 Schritten ueber */
      el.style.fontSize = size + 'px';
      var w = el.scrollWidth;
      if (w > maxW) { size = Math.max(min, size * maxW / w); el.style.fontSize = size + 'px'; }
      var guard = 8;
      while (guard-- > 0 && size > min && el.scrollWidth > maxW) {
        size = Math.max(min, size - 0.5);
        el.style.fontSize = size + 'px';
      }
      return size;
    }

    function render() {
      var s = layoutStage() || stage.clientWidth;
      if (!s) return;

      /* Figur */
      var r = checkedMotiv();
      if (r) {
        var src = r.dataset.src;
        if (src && figur.getAttribute('src') !== src) figur.setAttribute('src', src);
        var kat = r.dataset.kategorie || 'maedchen';
        wrap.style.setProperty('--fig-h', (FIG_H * (FIG_SCALE[kat] || 1)).toFixed(4));
        if (motivLabel) motivLabel.textContent = r.value;
      }

      /* Name: 56 pt auf 78,5 mm Druckbreite, max. 60 mm breit (wie im Generator) */
      var name = nameInput.value.trim() || GHOST_NAME;
      nameEl.textContent = name;
      fit(nameEl, s * 0.110, s * 0.36 + 2, s * 0.05); /* maxW = Boxbreite (0.36), sonst schrumpft es bis zum Minimum */ /* maxW = Boxbreite, sonst schrumpft es immer bis zum Minimum */
      nameEl.style.opacity = nameInput.value.trim() ? '1' : '0.45';
    }

    function showPanel(kat) {
      tabs.forEach(function (t) {
        var on = t.dataset.spardoseTab === kat;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      panels.forEach(function (p) { p.hidden = p.dataset.spardosePanel !== kat; });
    }

    function open() {
      wrap.classList.add('is-open');
      render();
    }

    wrap.querySelector('[data-spardose-close]').addEventListener('click', function () {
      wrap.classList.remove('is-open');
    });

    function zeigeFehler(input, el) {
      if (el) el.hidden = false;
      input.classList.add('is-invalid');
      fields.scrollIntoView({ block: 'center', behavior: 'smooth' });
      window.setTimeout(function () { input.focus({ preventScroll: true }); }, 350);
    }

    /* Ohne Namen kein Warenkorb */
    document.addEventListener('click', function (e) {
      var kaufBtn = e.target.closest('[data-add-to-cart], button[name="add"]');
      if (!kaufBtn) return;
      var btnFormEl = kaufBtn.closest('form');
      var btnForm = kaufBtn.getAttribute('form') || (btnFormEl && btnFormEl.getAttribute('id'));
      if (btnForm && btnForm !== fields.dataset.formId) return;
      if (!nameInput.value.trim()) {
        e.preventDefault();
        e.stopPropagation();
        zeigeFehler(nameInput, errorEl);
      }
    }, true);

    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        showPanel(t.dataset.spardoseTab);
        /* erstes Motiv der Kategorie vorwählen, falls noch keins aus dieser Kategorie gewählt ist */
        var cur = checkedMotiv();
        if (!cur || cur.dataset.kategorie !== t.dataset.spardoseTab) {
          var first = fields.querySelector('[data-spardose-motiv][data-kategorie="' + t.dataset.spardoseTab + '"]');
          if (first) first.checked = true;
        }
        open();
      });
    });

    motivRadios.forEach(function (r) {
      r.addEventListener('change', function () { open(); });
    });

    nameInput.addEventListener('focus', open);
    nameInput.addEventListener('input', function () {
      if (nameInput.value.trim()) {
        if (errorEl) errorEl.hidden = true;
        nameInput.classList.remove('is-invalid');
      }
      render();
    });

    if (showLink) {
      showLink.addEventListener('click', function () {
        open();
        wrap.scrollIntoView({ block: 'center', behavior: 'smooth' });
      });
    }
    img.addEventListener('load', render);
    figur.addEventListener('load', render);
    window.addEventListener('resize', render);

    if (document.fonts && document.fonts.ready) document.fonts.ready.then(render);
    render();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
